import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    font-size: 14px;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  padding: 0.9rem 1rem;\n  margin: 0;\n  border: none;\n  width: 100%;\n  font-size: 18px;\n  line-height: 1.6em;\n  outline: none;\n  background-color: transparent;\n  color: ", ";\n  font-family: ", ";\n  height: 190px;\n  &::placeholder {\n    color: rgba(44, 44, 44, 0.3);\n  }\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  & > span {\n    cursor: pointer;\n    position: absolute;\n    top: 15px;\n    right: 15px;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  top: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  border: 1px solid #cfd7da;\n  color: ", ";\n  background-color: ", ";\n  outline: none;\n  transition: all 0.3s ease;\n  border-radius: 4px;\n  &:hover {\n  }\n  label {\n    top: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { media, styled } from "@styles";
import { InputLabel } from "../InputLabel";

var getEdgeColor = function getEdgeColor(_ref) {
  var active = _ref.active,
      error = _ref.error,
      disabled = _ref.disabled,
      theme = _ref.theme;
  var hovered = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (disabled) {
    return theme.colors.disabled;
  }

  if (error) {
    return theme.colors.error;
  }

  if (hovered) {
    return theme.colors.secondary;
  }

  return active ? theme.colors.secondary : theme.colors.dark;
};

export var Wrapper = styled.div(_templateObject(), function (props) {
  return getEdgeColor(props);
}, function (props) {
  return props.whiteBg ? "#ffffff" : "transparent";
}, function (props) {
  return props.active ? "0" : "30px";
});
export var StyledInputLabel = styled(InputLabel)(_templateObject2(), function (props) {
  return props.active ? "0!important" : "30px";
});
export var Content = styled.span(_templateObject3());
export var InputWrapper = styled.div(_templateObject4());
export var Input = styled.textarea(_templateObject5(), function (props) {
  return props.theme.colors.baseFont;
}, function (props) {
  return props.theme.typography.extraFontFamily;
}, media.xxLargeScreen(_templateObject6()));